import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  sectionItem: {
    width: '42%',
    paddingVertical: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectionType: {
    ...Fonts.type.bold,
    marginTop: 4,
    fontSize: 18,
  },
  sectionDays: {
    marginTop: 6,
    fontSize: 14.6,
  },
  sectionPrice: {
    ...Fonts.type.bold,
    marginTop: 4,
    fontSize: 18,
  },
});
